// extracted by mini-css-extract-plugin
module.exports = {"hidden":"index_hidden_2l-DU","dropdown":"index_dropdown_2f6IJ","wrapperPlaceholder":"index_wrapperPlaceholder_3bCwL"};